export const MARKEL_EXEMPTED_ZIPCODES = [
  '97500',
  '98771',
  '98752',
  '98760',
  '98750',
  '98701',
  '98741',
  '98775',
  '98730',
  '98702',
  '98763',
  '98731',
  '98731',
  '98729',
  '98731',
  '98763',
  '98750',
  '98709',
  '98771',
  '98754',
  '98726',
  '98732',
  '98728',
  '98730',
  '98733',
  '98735',
  '98711',
  '98712',
  '98727',
  '98714',
  '98733',
  '98716',
  '98721',
  '98718',
  '98750',
  '98776',
  '98755',
  '98733',
  '98722',
  '98723',
  '98742',
  '98719',
  '98719',
  '98778',
  '98725',
  '98754',
  '98778',
  '98771',
  '98735',
  '98734',
  '98750',
  '98811',
  '98812',
  '98870',
  '98813',
  '98830',
  '98880',
  '98814',
  '98815',
  '98816',
  '98832',
  '98817',
  '98860',
  '98818',
  '98850',
  '98880',
  '98820',
  '98826',
  '98819',
  '98810',
  '98800',
  '98883',
  '98821',
  '98890',
  '98822',
  '98823',
  '98824',
  '98825',
  '98826',
  '98827',
  '98880',
  '98828',
  '98829',
  '98840',
  '98831',
  '98833',
  '98834',
  '98611',
  '98612',
  '98620',
  '98600'
];
